<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="我要提现"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div class="tixianBox">
      <div class="hd">
        <div class="titbox">
          <div class="labelTit">
            <span class>到账银行卡</span>
            <em class="price">{{bank}}</em>
          </div>
          <div class="grey">每次交易会扣交易手续费10%，平台打款后，需等待银行处理，一般1-3个工作日到账。</div>
        </div>
        <div class="ft" @click="selectBankShow = true">
          银行卡
          <van-icon name="arrow" />
        </div>
      </div>

      <div class="bd">
        <div class="flexbox flexmid titbox" id="bankCheckedClick">
          <div class="labelTit">提现金额</div>
        </div>

        <div class="inputBox">
          <span class="rmb">¥</span>
          <input class="cashnumber" :value="input.Cash" type="text" id placeholder />
          
        </div>
        <div class="grey">
          可提现额度：
          <em class="txprice price">{{hasCash}}</em> 元
          <span @click="onAllCash" class="price qbtx-btn">全部提现</span>
        </div>
        <section class="btn-area">
          <van-button round block color="orange" @click="onSubmit" size="large">提现</van-button>
        </section>
        <div class="tx-tips">
          提现是指把可提取额度转到您的银行卡中,请先到银行卡管理里面添加银行卡,单笔提现至少
          <em class="price">¥100</em>或以上。
        </div>
      </div>
    </div>

    <!-- 银行卡选择 popup start -->
    <van-popup v-model="selectBankShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        cancel-button-text
        confirm-button-text="确定"
        :visible-item-count="3"
        :default-index="defalutIndex"
        @confirm="onSelectBank"
        @cancel="selectBankShow = false"

      />
    </van-popup>
    <!-- 银行卡选择 popup end -->
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      selectBank: "",
      selectBankShow: false,
      bank:"",
      defalutIndex:0,
      hasCash:0,
      ReceiptsApiModelList:null,
      defaultModel:null,
      columns:[],
      input:{
        ReceiptsId:"",
        Cash:0
      }
    };
  },
  components: {},
  mounted() {
    var _query = this.$route.query;
    this.hasCash=_query.HasCash;
    this.init();
  },
  methods: {
    init() {
      var that=this;
      var options = {
        type: "GetReceiptsApiModelListSearch"
      };
      this.$store.dispatch(options).then(
        res => {
          //console.log(res);
          that.ReceiptsApiModelList=res.ReceiptsApiModelList;
          var findDefaluts=that.ReceiptsApiModelList.filter(x=>x.IsDefault==true);
          if(findDefaluts.length>0){
              that.defaultModel=findDefaluts[0];
              that.input.ReceiptsId=that.defaultModel.ReceiptsId;
              that.defalutIndex=that.ReceiptsApiModelList.findIndex(x=>x.IsDefault==true);
              that.bank=that.defaultModel.Bank;
          }
          that.ReceiptsApiModelList.forEach(x => {
            that.columns.push(x.Bank);
          });

        },
        error => {}
      );
    },
    onAllCash(){
      var that=this;
      that.input.Cash=that.hasCash;
    },
    onSubmit(){
      console.log(this.input);
      if(this.input.ReceiptsId==""){
          Toast("请选择银行卡再进行提交");
          return false;
      }
      if(this.input.Cash==0||this.input.Cash<100){
        Toast("提现金额必须大于等于100");
        return false;
      }
      var  params = this.input;
      Object.assign(params,{
        type: "AddDistributionWithdraw"
      });
      this.$store.dispatch(params).then(res=>{
        //console.log(res);
         Toast(res.Message);
        if(res.IsSuccess){
           that.hasCash=that.hasCash-that.input.Cash;
        }
        else{

        }
      },error=>{})


    },
    onSelectBank(val,index){
      var that=this;
      var findModel=that.ReceiptsApiModelList[index];
      that.input.ReceiptsId=findModel.ReceiptsId;
      that.defalutIndex=index;
      that.bank=findModel.Bank;
      that.selectBankShow = false;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onBandChange(picker, value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
      this.selectBank = value;
    }
  }
};
</script>

<style scoped>
/**我要提现**/
.tixianBox > .hd {
  padding: 20px 15px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
}
.tixianBox .ft {
  color: green;
  margin-left: 20px;
  display: flex;
  align-items: center;
}
.tixianBox .labelTit {
  white-space: nowrap;
  margin-right: 6px;
}
.tixianBox > .hd .price {
  margin-left: 6px;
  color: orange;
}
.tixianBox > .hd .grey {
  margin-top: 4px;
  font-size: 12px;
  color: #666;
}
.tixianBox > .bd {
  padding: 20px 15px;
}
.tixianBox .titbox {
  font-size: 15px;
  margin-bottom: 6px;
  flex: 1;
}
.tixianBox > .bd .inputBox {
  border: 1px solid #cacaca;
  height: 40px;
  position: relative;
  background: #e9e9e9;
}
.tixianBox > .bd .inputBox .rmb {
  font-weight: 700;
  margin: 0 10px;
  font-size: 21px;
  color: #777;
  line-height: 40px;
  position: absolute;
  left: 0;
  top: 0;
}
.tixianBox > .bd .inputBox .cashnumber {
  width: 100%;
  height: 100%;
  background-color: #e9e9e9;
  padding-left: 30px;
  font-size: 21px;
}
.tixianBox > .bd > .grey {
  font-size: 12px;
  color: #666;
  margin-top: 6px;
}
.tixianBox > .bd > .grey .qbtx-btn {
  margin-left: 12px;
  color: orange;
}
.tixianBox > .bd > .tx-tips {
  line-height: 1.5;
  font-size: 12px;
  color: #888;
}
.tixianBox > .bd > .tx-tips .price {
  color: orange;
}
.btn-area {
  margin: 30px 0 15px;
}
</style>
